import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridApi, GridOptions } from 'ag-grid-community';
import { AG_GRID_DEFAULT_OPTIONS, onlyLinkFollowingByIdButton } from '../../../../core/config/aggrid.default.config';
import { AppRoutes } from '../../../../shared/route-paths.const';
import { VentaDtoOut } from '../../../models/venta.model';
import { ContabilidadVentasService } from '../../../services/contabilidad-venta.service';

@Component({
  selector: 'app-venta-list',
  standalone: true,
  imports: [CommonModule, RouterModule, AgGridAngular, MatIconModule],
  templateUrl: './venta-list.component.html',
  styleUrl: './venta-list.component.scss',
})
export class VentaListComponent implements OnInit {
  ventas: VentaDtoOut[] = [];
  gridApi!: GridApi;

  constructor(
    private readonly service: ContabilidadVentasService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.obtenerGastos();
  }

  gridOptions: GridOptions = {
    ...AG_GRID_DEFAULT_OPTIONS,
    onGridReady: (params) => (this.gridApi = params.api),
  };

  columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID' },
    { field: 'fechaAsientoContable', headerName: 'Fecha Asiento Contable', type: 'dateColumn' },
    { field: 'metodoPagoNombre', headerName: 'Método de Pago' },
    { field: 'empresaFacturadoraNombre', headerName: 'Empresa Facturadora' },
    { field: 'observaciones', headerName: 'Observaciones' },
    { field: 'validado', headerName: 'Validado', type: 'booleanColumn' },
    onlyLinkFollowingByIdButton(AppRoutes.CONTABILIDAD_ONDA.VENTAS),
  ];

  obtenerGastos(): void {
    this.service.obtenerVentas().subscribe({
      next: (data) => {
        this.ventas = data;
      },
      error: (err) => {
        console.error('VentaListComponent - Error:', err);
      },
    });
  }

  onRowDoubleClicked(event: any): void {
    this.router.navigate([`${AppRoutes.CONTABILIDAD_ONDA.VENTAS}/${event.data.sepaId}`]);
  }

  crearVentaEfectivo(): void {
    this.router.navigate([AppRoutes.CONTABILIDAD_ONDA.VENTAS_NEW]);
  }
}
